import { useRef, useState } from 'react';

import { debounce } from 'underscore';

import { BUTTON_WIDTH } from './QuizFilter';

export const SEARCH_QUERY_WAIT = 200;

interface UseSearchFieldParams {
  initialSearchQuery?: string;
  initialFieldVisible?: boolean;
}

export function useSearchField({
  initialSearchQuery = null,
  initialFieldVisible = false,
}: UseSearchFieldParams = {}) {
  const [isFieldVisible, setIsFieldVisible] = useState(initialFieldVisible);
  const [searchQuery, setSearchQuery] = useState(initialSearchQuery);
  const [fieldMaxWidth, setFieldMaxWidth] = useState(BUTTON_WIDTH);
  const filterSiblingRef = useRef<HTMLDivElement>(null);

  const handleSearchQueryChange = useRef(
    debounce<(query: string) => void>((searchQuery) => {
      setSearchQuery(searchQuery);
    }, SEARCH_QUERY_WAIT)
  ).current;

  return {
    isFieldVisible,
    setIsFieldVisible,
    searchQuery,
    handleSearchQueryChange,
    filterSiblingRef,
    fieldMaxWidth,
    setFieldMaxWidth,
  };
}
